import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react/jsx-runtime";
export function StepIndicator({ currentStep, totalSteps, labels }) {
    return (_jsxs(Fragment, { children: [_jsx("hr", { className: "border-line border-line-lesser" }), _jsx("section", { className: `step-indicator steps-${totalSteps}`, children: Array.from({ length: totalSteps }, (_, i) => {
                    const step = i + 1;
                    let className = "step-item";
                    if (step < currentStep)
                        className += " completed";
                    else if (step === currentStep)
                        className += " active";
                    return (_jsxs("div", { className: className, children: [_jsx("div", { className: "step-number", children: step }), labels[i] && _jsx("span", { className: "step-label", children: labels[i] })] }, step));
                }) })] }));
}
